<style src="css/login.css" scoped></style>
<template>
  <div class="bgImg">
    <img class="loginLogo" src="../../assets/common/logo02.jpg" alt=""/>
    <div>
      <div class="loginBtn" @click="getAuthUrl">微信登录</div>
    </div>
  </div>
</template>
<script>
import {getAuthUrl, wxLogin} from '@/api/user'

export default {
  data() {
    return {
    };
  },
  computed: {},
  created() {
    const code = this.$utils.getQueryString('code') || this.$route.query.code
    const redirectUrl = this.$route.query.redirectUrl
    const applicationType = this.$route.query.at // 申请类型,为了登录成功之后直接跳转到对应的申请页面
    console.log('wx-auth code=' + code + ', applicationType=' + applicationType)
    this.saveRedirectUrl(applicationType, redirectUrl)
    if (code) {
      this.doLogin(code)
    } else {
      this.getAuthUrl()
    }
  },
  methods: {
    async getAuthUrl() {
      let resp = await getAuthUrl();
      location.href = resp.data
    },
    async doLogin(code) {
      let resp = await wxLogin(code);
      this.$utils.storeLoginInfo(resp.data)
      this.gotoRedirectUrl()
    },
    gotoRedirectUrl() {
      let url = localStorage.getItem('loginRedirectUrl')
      console.log('loginRedirectUrl', url)
      if (this.$utils.isBlank(url)) url = '/'
      location.href = url
    },
    saveRedirectUrl(type, url) {
      if (type) {
        url = `${this.$utils.origin()}#/application?type=${type}`
      }
      if (this.$utils.isBlank(url)) return
      localStorage.setItem('loginRedirectUrl', url)
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/user/wx-auth.vue